export const RESET_REDUX_STORE = 'RESET_REDUX_STORE';
